import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import toast, { Toaster } from "react-hot-toast";
import { useParams } from "react-router-dom";

import { S3_URL } from "common/constants/apiUrls";
import {
  BRANCH_ADMIN,
  BRANCH_CONSULTANT,
  END_USER,
  bankId,
  orderType,
  pageSize,
} from "common/constants/constants";
import {
  MANAGE_CONSULTANT,
  MANAGE_EG_ADMIN,
} from "common/constants/permissionKeys";
import { scrolToTop } from "common/utils/utilities";
import TableCommon from "components/common/dynamicTable/DynamicTable";
import BranchUserFilter from "components/common/filterBar/BranchUserFilter";
import Loader from "components/common/loader/Loader";
import NoDataFound from "components/common/noDataFound/NoDataFound";
import Paginate from "components/common/pagination/Paginate";
import { usePermission } from "hooks/permission/usePermission";

import { getProductList } from "services/ProductsServices";
import { getUsers } from "services/UserManagementServices";

import "./branches.scss";
import { useTranslation } from "react-i18next";
const BranchUsers = () => {
  const { t, i18n } = useTranslation();
  const { id: branchId } = useParams();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false);
  const [pagination, setPagination] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [productList, setProductList] = useState([]);

  const [rolesList, setRolesList] = useState([]);

  const { checkPermission } = usePermission();

  const permissionToManageEA = checkPermission(MANAGE_EG_ADMIN);
  const permissionToManageEC = checkPermission(MANAGE_CONSULTANT);

  const [orderByList, setOrderByList] = useState();
  const [filters, setFilters] = useState({
    orderType: "DESC",
    searchString: "",
    orderBy: "",
    products: [],
    roles: [],
  });

  useLayoutEffect(() => {
    const languageChangeHandler = () => {
      setOrderByList(
        JSON.parse(localStorage.getItem("users")).map((elem) => {
          return { value: elem.key, name: t("users-list-sort." + elem.key) };
        })
      );
    };
    setRolesList([
      {
        name: BRANCH_ADMIN,
        translatedValue: t("#EA"),
        roleId: "302b630d-22dc-4304-9225-6884d41cca7a",
      },
      {
        name: BRANCH_CONSULTANT,
        translatedValue: t("#EC"),
        roleId: "07c5abe9-2477-459f-a432-be10a275f620",
      },
      {
        name: END_USER,
        translatedValue: t("#EU"),
        roleId: "1dcd5e01-743e-4ef6-a9d0-dffa336967d5",
      },
    ]);

    i18n.on("languageChanged", languageChangeHandler);

    return () => {
      i18n.off("languageChanged", languageChangeHandler);
    };
  }, [i18n]);

  const handleResetFilters = () => {
    setFilters({
      orderType: "DESC",
      searchString: "",
      orderBy: "",
      roles: [],
      products: [],
    });
  };
  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };

  const handleChangeFilters = (key, value) => {
    setFilters((pre) => {
      let obj = { ...pre };
      obj[key] = value;
      return obj;
    });
  };

  const getProductsList = async () => {
    const result = await getProductList();
    setProductList(result?.payLoad?.items);
  };
  const headings = [
    t("user-name"),
    t("email"),
    t("last-activity"),
    t("status"),
    t("role"),
    t("owned-products"),
    t("actions"),
  ];
  const handleNextPage = (data) => {
    const { selected } = data;
    setPagination((pre) => {
      return { ...pre, currentPage: selected + 1 };
    });
    handleRefresh();
  };
  const branchUsersHandler = async () => {
    let userRole = "";
    if (filters.roles.length > 0) {
      filters.roles.forEach((el, i) => {
        userRole += `${i > 0 ? "," : ""}` + "%23" + el.substring(1);
      });
    } else {
      userRole = "%23EA,%23EU,%23EC";
    }

    let params = {
      bankId: bankId,
      branchId: branchId,
      pageSize,
      pageNumber: pagination.currentPage || 1,
      filter: "",
      role: userRole,
      ...filters,
    };
    setIsLoading(true);
    const result = await getUsers(params);
    if (result.success) {
      const { totalCount, pageSize, totalPages, currentPage, items } =
        result.payLoad;
      if (!items || items.length === 0) {
        setIsLoading(false);
        setIsEmpty(true);
      } else {
        setIsEmpty(false);
        setUsers(items);
        setPagination({ totalCount, pageSize, totalPages, currentPage });
      }
    } else if (result.status === 422) {
      setIsEmpty(true);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getProductsList();
  }, []);

  useEffect(() => {
    branchUsersHandler();
  }, [
    filters.orderType,
    filters.orderBy,
    filters.searchString,
    filters.products,
    filters.roles,
    refresh,
  ]);
  const renderBranchUsers = () => {
    if (isLoading) {
      return <Loader />;
    } else if (!isEmpty) {
      return (
        <>
          <TableCommon
            heading={headings}
            detailLink={"branches/"}
            name={"#EC"}
            body={users}
            permissionToEdit={permissionToManageEA || permissionToManageEC}
            tableStyle={{
              minHeight: "40vh",
              maxHeight: "40vh",
            }}
          />
          <Paginate
            totalPages={pagination.totalPages}
            handleNextPage={handleNextPage}
            currentPage={pagination.currentPage}
          />
        </>
      );
    } else {
      return <NoDataFound />;
    }
  };

  return (
    <div>
      <Row className="branch-details">
        <BranchUserFilter
          handleChange={handleChangeFilters}
          handleSubmit={handleRefresh}
          orderByList={orderByList}
          productList={productList}
          rolesList={rolesList}
          filters={filters}
          resetFilters={handleResetFilters}
          searchPlaceholder={t("user-name")}
        />
        {renderBranchUsers()}
      </Row>
    </div>
  );
};

export default BranchUsers;
